import { Brand } from 'effect'

type ProductId = string & Brand.Brand<'Product'>

const ProductId = {
  fromString: Brand.nominal<ProductId>(),
}

export default ProductId
